import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { PaginationModel } from '@shared/models/pagination.model';
import {PageManagerResponse} from "@services/back-office/model/pageManagerResponse";
import {ManagerSearchRequest} from "@services/back-office/model/managerSearchRequest";

export enum AdministratorsActionTypes {
  LoadAdministrators = '[Administrators] Load Administrators',
  LoadAdministratorsSuccess = '[Administrators] Load Administrators Success',
  LoadAdministratorsFailure = '[Administrators] Load Administrators Failure',
  DeleteAdministrators = '[Administrators] Delete Administrators',
  DeleteAdministratorsSuccess = '[Administrators] Delete Administrators Success',
  DeleteAdministratorsFailure = '[Administrators] Delete Administrators Failure',
  ChangePage = '[Administrators] Change Page',
  SetInitialPagination = '[Administrators] Set Initial Pagination',
  SetFilter = '[Administrators] Set Filter',
  ClearFilter = '[Administrators] Clear Filter',
  SetInitialState = '[Administrators]Set Initial State',
}

/** Load Administrators */
export class LoadAdministrators implements Action {
  readonly type = AdministratorsActionTypes.LoadAdministrators;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadAdministratorsSuccess implements Action {
  readonly type = AdministratorsActionTypes.LoadAdministratorsSuccess;
  constructor(public payload: PageManagerResponse) { }
}

export class LoadAdministratorsFailure implements Action {
  readonly type = AdministratorsActionTypes.LoadAdministratorsFailure;
  constructor(public payload: {error: HttpErrorResponse}) { }
}

/** Delete Administrators */
export class DeleteAdministrators implements Action {
  readonly type = AdministratorsActionTypes.DeleteAdministrators;
  constructor(public payload: string) {}
}

export class DeleteAdministratorsSuccess implements Action {
  readonly type = AdministratorsActionTypes.DeleteAdministratorsSuccess;
  constructor(public payload: void) { }
}

export class DeleteAdministratorsFailure implements Action {
  readonly type = AdministratorsActionTypes.DeleteAdministratorsFailure;
  constructor(public payload: {error: HttpErrorResponse}) { }
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = AdministratorsActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = AdministratorsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = AdministratorsActionTypes.SetFilter;
  constructor(public payload: ManagerSearchRequest) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = AdministratorsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = AdministratorsActionTypes.SetInitialState;
}

export type AdministratorsActions =
  | LoadAdministrators
  | LoadAdministratorsSuccess
  | LoadAdministratorsFailure
  | DeleteAdministrators
  | DeleteAdministratorsSuccess
  | DeleteAdministratorsFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

